import { cn } from '../../lib/utils';
export const Card = ({ className, ...props }) => <div className={cn('ui-card', className)} {...props} />;
export const CardHeader = ({ className, ...props }) => <div className={cn('ui-card-header', className)} {...props} />;
export const CardTitle = ({ className, ...props }) => <h3 className={cn('ui-card-title', className)} {...props} />;
export const CardDescription = ({ className, ...props }) => <p className={cn('ui-card-description', className)} {...props} />;
export const CardContent = ({ className, ...props }) => <div className={cn('ui-card-content', className)} {...props} />;
